import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Prestasione = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [prestasi, setPrestasi] = useState(null);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    judul: "",
    deskripsi: "",
    tanggal: "",
    gambar: null,
  });

  const fetchPrestasi = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/prestasi/${id}`
      );
      setPrestasi(res.data);
      setForm({
        judul: res.data.judul || "",
        deskripsi: res.data.deskripsi || "",
        tanggal: res.data.tanggal?.split("T")[0] || "",
        gambar: null,
      });
    } catch (err) {
      toast.error("Gagal mengambil data prestasi.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrestasi();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleDeleteMedia = async () => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}api/prestasi/${id}/media/${prestasi.gambar.fileId}`
      );
      toast.success("Gambar berhasil dihapus.");
      fetchPrestasi();
    } catch {
      toast.error("Gagal menghapus gambar.");
    }
  };

  const handleDeletePrestasi = async () => {
    if (!window.confirm("Yakin ingin menghapus data ini?")) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}api/prestasi/${id}`);
      toast.success("Prestasi berhasil dihapus.");
      setTimeout(() => navigate("/"), 1500);
    } catch {
      toast.error("Gagal menghapus prestasi.");
    }
  };

  const handleUpdate = async () => {
    try {
      const formData = new FormData();
      formData.append("judul", form.judul);
      formData.append("deskripsi", form.deskripsi);
      formData.append("tanggal", form.tanggal);
      if (form.gambar) formData.append("gambar", form.gambar);

      await axios.put(
        `${process.env.REACT_APP_API_URL}api/prestasi/${id}`,
        formData
      );
      toast.success("Data berhasil diperbarui.");
      fetchPrestasi();
    } catch {
      toast.error("Gagal memperbarui data.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <ToastContainer />
      <div className="max-w-3xl mx-auto bg-white rounded shadow p-6">
        {loading ? (
          <p className="text-center text-gray-600">Memuat data prestasi...</p>
        ) : !prestasi ? (
          <p className="text-center text-red-500">Data tidak ditemukan.</p>
        ) : (
          <>
            {/* Gambar */}
            {prestasi.gambar?.filename && (
              <div className="relative mb-4">
                <img
                  src={`${process.env.REACT_APP_API_URL}api/prestasi/gambar/${prestasi.gambar.filename}`}
                  alt={prestasi.judul}
                  className="w-full max-h-[400px] object-contain rounded"
                />
                <button
                  onClick={handleDeleteMedia}
                  className="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                >
                  ❌
                </button>
              </div>
            )}

            {/* Form */}
            <div className="space-y-4">
              <input
                type="text"
                value={form.judul}
                onChange={(e) => setForm({ ...form, judul: e.target.value })}
                className="w-full border rounded p-2"
                placeholder="Judul"
              />
              <textarea
                value={form.deskripsi}
                onChange={(e) =>
                  setForm({ ...form, deskripsi: e.target.value })
                }
                className="w-full border rounded p-2"
                placeholder="Deskripsi"
              />
              <input
                type="date"
                value={form.tanggal}
                onChange={(e) => setForm({ ...form, tanggal: e.target.value })}
                className="w-full border rounded p-2"
              />
              <input
                type="file"
                accept="image/*"
                onChange={(e) =>
                  setForm({ ...form, gambar: e.target.files[0] })
                }
                className="w-full border rounded p-2"
              />

              <div className="flex gap-3">
                <button
                  onClick={handleUpdate}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
                >
                  Simpan Perubahan
                </button>
                <button
                  onClick={handleDeletePrestasi}
                  className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded"
                >
                  Hapus Prestasi
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Prestasione;
